import React from "react";

interface BusinessTypeOptionCardProps {
    inputId: string;
    name: string;
    value: string;
    label: string;
    description: string;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    checked: boolean;
    disabled?: boolean;
    onChange: (value: string) => void;
}

const BusinessTypeOptionCard: React.FC<BusinessTypeOptionCardProps> = ({
    inputId,
    name,
    value,
    label,
    description,
    icon,
    checked,
    disabled = false,
    onChange,
}) => {
    const Icon = icon;

    return (
        <label
            htmlFor={inputId}
            className={`business-type d-flex align-items-start gap-3 w-100 rounded-2 p-3 cursor-pointer
        ${checked ? "active" : ""}
      `}
        >
            <input
                id={inputId}
                name={name}
                type="radio"
                value={value}
                checked={checked}
                disabled={disabled}
                onChange={() => onChange(value)}
                className="form-check-input mt-2 flex-shrink-0"
            />

            <div className="flex-shrink-0 d-flex align-items-center justify-content-center">
                <Icon width={55} height={53} className="img-fluid" />
            </div>

            <div className="flex-grow-1 min-w-0">
                <div className="fs-5 text-dark mb-1">{label}</div>
                <div className="fs-7 text-grey mb-0">{description}</div>
            </div>
        </label>
    );
};

export default React.memo(BusinessTypeOptionCard);
